import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { signupSchema, type SignupInput } from './signup.schema';
import { makeApi } from '../api/client';
import { ApiError, type ApiProblem } from '@dhuttu/ui';
import { parseProblem } from '../api/errors';
import { useState } from 'react';

export default function SignupRoute() {
  const navigate = useNavigate();
  const [problem, setProblem] = useState<ApiProblem | null>(null);
  const { register, handleSubmit, formState: { errors } } = useForm<SignupInput>({ resolver: zodResolver(signupSchema) });
  const api = makeApi(async () => '');
  const mut = useMutation({
    mutationFn: (data: SignupInput) =>
      api.org.signup({ body: { org_name: data.orgName, owner_email: data.ownerEmail, owner_auth0_sub: 'pending', gstin: data.gstin } }),
    onSuccess: () => navigate('/pending'),
    onError: async (err) => setProblem(await parseProblem(err)),
  });
  return (
    <form onSubmit={handleSubmit((d) => mut.mutate(d))} className="mx-auto max-w-md p-8 space-y-4">
      <h1 className="text-2xl font-bold text-primary">Create your merchant</h1>
      {problem && <ApiError problem={problem} />}
      <label className="block">Merchant name
        <input {...register('orgName')} className="mt-1 w-full border rounded p-2" />
      </label>
      {errors.orgName && <p className="text-sm text-accent">{errors.orgName.message}</p>}
      <label className="block">Owner email
        <input type="email" {...register('ownerEmail')} className="mt-1 w-full border rounded p-2" />
      </label>
      {errors.ownerEmail && <p className="text-sm text-accent">{errors.ownerEmail.message}</p>}
      <label className="block">GSTIN (optional)
        <input {...register('gstin')} className="mt-1 w-full border rounded p-2" />
      </label>
      <button type="submit" disabled={mut.isPending} className="rounded bg-primary px-4 py-2 text-white">Create merchant</button>
    </form>
  );
}
